import React, { Component } from "react";
//import ReactDOM from "react-dom";
//import classNames from "classnames";
import { Link } from "react-router-dom";
import RequestLoader from "../spinner";
import { connect } from "react-redux";
import ImageEditor from '../views/Dashboard/ImageEditor'
import Swal from "sweetalert2";
//import { rgbToHex } from "@coreui/coreui/dist/js/coreui-utilities";
import Axios from "axios";

//import Car from "../carbodyparts/car";
//import CarDentTable from "../carbodyparts/CarDentTable";
import { configuration } from "../appConfig";
import PlotDentOnImage from "./PlotDentOnImage/PlotDentOnImage";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import CarDentPositionTable from "../carbodyparts/CarDentPositionTable";
import FormGroup from 'reactstrap/lib/FormGroup';
import Label from 'reactstrap/lib/Label';
import Input from 'reactstrap/lib/Input';
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
// const Toast = Swal.mixin({
//   toast: true,
//   position: "top-end",
//   showConfirmButton: false,
//   timer: 3000
// });

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

class PartDetails extends Component {
  state = {
    A: 0,
    B: 0,
    C: 0,
    Size_of_damage_A: "0 - 3 mm",
    Size_of_damage_B: "0 - 3 mm",
    Size_of_damage_C: "0 - 3 mm",
    prepopulateComment: "",
    toggle_update_btn_loader: false,
    loading: false,
    large: false,
    selectedFile: "",
    order: {
      vinNumber: "",
      orderNumber: Math.round(Math.random() * 100000000),
      issuedOn: new Date(),
    },
    // partDetails: null,
    twoDView: true,
    partName: this.props.history.location.pathname.split("/")[2],
    prePopulatePartName : this.props.history.location.pathname.split("/")[2].split('_')[1],
    vinNumber: null,
    vinfolderList: [],
    showTwoDView: true,
    selectedPartInfo: [],
    partDetails: [],
    showEditor: false,
    data64Url : '',
    imageUrl : '',
    softwareType: '',
    loader: true,
    data64ImgError: false,
    isImgExist:true,
    words: {},
    lang: "En",
  };
  toggleLarge = () => {
    this.setState({
      large: !this.state.large,
    });
  };
  componentDidMount() {
    const selectedFile = localStorage.getItem("selectedFile");
    this.setState({ vinNumber: selectedFile });
    // this.getData(selectedFile);
    this.getData()
    this.getPartData()
    this.getPartDetails();
    this.getBase64Url();
    this.getLang()
  }

  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({
        words: res.data,
        lang: localStorage.getItem("lang"),
      });
    });
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    //alert(nextProps.lang+"123")
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }

  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };
  getData = async() => {
    Axios.get(
        `${configuration.getData}?vin=${localStorage.getItem("selectedFile")}&partnerId=${localStorage.getItem("partnerId")}`
      ).then((r) => {
        if(r.data.SoftwareType){
          this.setState({softwareType: r.data.SoftwareType})
        }else{
          this.setState({softwareType: 'HailSoft'})
        }
      }).catch(error=>alert('An error occured please try again'));
  }

  getPartData = () => {
    const partnerId = localStorage.getItem("partnerId");
      const vin = localStorage.getItem("selectedFile");
      Axios.get(
        `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`
      ).then((r) => {
        //  console.table(r.data.Dents[0].DentPos);
        if (r.data) {
          this.setState({ data: r.data })
          const finalPartData = r.data.Dents.filter((r) => r.Part == this.state.prePopulatePartName)[0];
          this.setState({
             A: finalPartData.A, 
             B: finalPartData.B, 
             C: finalPartData.C,
          });
          if(finalPartData.Size_of_damage_A !== ''){
            this.setState({
              Size_of_damage_A : finalPartData.Size_of_damage_A
           });
          }if(finalPartData.Size_of_damage_B !== ''){
            this.setState({
              Size_of_damage_B : finalPartData.Size_of_damage_B
           });
          }if(finalPartData.Size_of_damage_C !== ''){
            this.setState({
              Size_of_damage_C : finalPartData.Size_of_damage_C
           });
          }if(finalPartData.Comment !== ''){
            this.setState({
              prepopulateComment : finalPartData.Comment
           });
          }
        }else{
          alert('Something went wrong')
        }
        this.setState({
          loading: false
        })
      }).catch(error=>this.setState({ loading: false }));
  }

  updatePartDetail = () => {
    var imageEditorCanvas = document.getElementsByClassName("lower-canvas");
    var base64image = imageEditorCanvas[0].toDataURL("image/jpeg", 1.0);
    // Validation here 
    this.setState({ toggle_update_btn_loader: true });
    const dentsData  = this.state.data.Dents
    let index 
    let updatePart = dentsData.filter( (item,i) =>{
      if(item.Part === this.state.prePopulatePartName){
        index = i
      }
      return item.Part === this.state.prePopulatePartName
    })
    // let indexOfPart = dentsData.findIndex((element) => {
    //   return element.Part === this.state.prePopulatePartName
    // });
    updatePart[0].A = parseInt(this.state.A)
    updatePart[0].Size_of_damage_A = this.state.Size_of_damage_A
    updatePart[0].B = parseInt(this.state.B)
    updatePart[0].Size_of_damage_B = this.state.Size_of_damage_B
    updatePart[0].C = parseInt(this.state.C)
    updatePart[0].Size_of_damage_C = this.state.Size_of_damage_C
    updatePart[0].Comment = this.state.prepopulateComment
    updatePart[0].TotalDents = (parseInt(this.state.A) + parseInt(this.state.B) + parseInt(this.state.C))
    dentsData[index] = updatePart[0]
    const finalPostData = this.state.data
    finalPostData.Dents = dentsData
    const url =
    configuration.PostEditorChanges +
    `?partnerId=${localStorage.getItem(
      "partnerId"
    )}&vin=${localStorage.getItem("selectedFile")}&dents=${updatePart[0].TotalDents}`;

    let ImageUploadData = JSON.stringify({
      partnerId : localStorage.getItem("partnerId"),
      vin: localStorage.getItem("selectedFile"),
      base64image,
      imageName: `${this.state.partName}.jpg`
    })
    Axios.post(url, finalPostData).then((res) => {
      Axios.post(configuration.updateBase64, ImageUploadData).then((res) => {
        if(res.data.success){
          Toast.fire({
            type: "success",
            title: "Data saved successfully",
          });
        }
      }).catch(error => alert('Something went wrong please try again later'))
    })
    .catch(error => {
      if(error.response.status === 404){
        alert('File does not exist. File could not be replaced.')
      } else {
        alert('Something went wrong please try again later')
      }
    })
    .finally(() => {
      this.setState({ toggle_update_btn_loader: false });
    });
  };

  getBase64Url = async() =>{
    const partner_id = localStorage.getItem("partnerId");
    const vin_number = localStorage.getItem("selectedFile");
    let img_name;
    if(this.props.url !== ''){
      img_name = this.props.url.split('/')[6]
      this.setState({ extraPartName:img_name })
    } else {
      img_name = this.props.history.location.pathname.split("/")[2];
    }
    const response = await Axios.get(configuration.getBase64,{
      params: {
        partner_id,
        vin_number,
        img_name
      },
    }).then().catch(err => {
        this.setState ({
          ...this.state,
          loader : false,
          data64ImgError: true
        })
    });
    if(response !== undefined){
      this.setState ({
        ...this.state,
        data64Url: response.data.base64_img,
        imageUrl: img_name,
        loader : false
      })
    }
  }
  handleChange = (e) => {
    this.setState({
      customerInfo: {
        ...this.state.customerInfo,
        [e.target.name]: e.target.value,
      },
    });
  };
  customerInfo = async () => {
    //alert('No Partner Id selected! Please login.')

    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    if (partnerId) {
      const res = await Axios.get(
        configuration.getCustomerInfo +
          "?partnerId=" +
          partnerId +
          "&vin=" +
          vin
      );
      if (res.data.length) {
        this.setState({ customerInfo: res.data[0] });
      }
    } else {
      // this.props.history.push('/login');
      // alert('No Partner Id selected! Please login.')
    }
  };
  getPartDetails = async () => {
    const part = this.props.history.location.pathname.split("/")[2];
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");
    if (partnerId) {
      const response = await Axios.get(
        configuration.GetPartDetails +
          "?vin=" +
          selectedFile +
          "&partnerId=" +
          partnerId +
          "&part=" +
          part
      );
      //
      // console.table(response.data);
      let stringr = response.data.json;
      if (stringr) {
        let partarr = stringr && stringr.split("\r\n");
        let objArray = partarr.map((r) => {
          return r.split(" ");
        });

        this.setState({ partDetails: objArray });
      }

      //console.table(objArray);
    } else {
      this.props.history.push("/login");
    }
  };

  selectFile = (e) => {
    localStorage.setItem("selectedFile", e.target.value);
    this.setState({ selectedFile: e.target.value });
  };
  showDummyData = () => {
    //this.getData(this.state.selectedFile);
    this.customerInfo();
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  SizeDropdown = (size, index) => {
    const arr = [0, 10, 20, 30, 40, 50, 60, 70, 80];
    return (
      <select value={size} onChange={(e) => this.change(e.target.value, index)}>
        {arr.map((row, i) => (
          <option key={i}>{row}</option>
        ))}
      </select>
    );
  };

  toggle = () => {
    this.setState({
      modal: !this.state.modal,
    });
  };

  render() {
    const {partName,data64Url, data} = this.state
    const client  = localStorage.getItem("client");
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const { orderNumber } = this.state.order;

    //   const dentInfo = scanResult.resultTXT;
    const img = this.props.history.location.pathname.split("/")[2];
    const dentPositionPartName = img.split('_')[1]
    // const DentEditorAccessPartnerId=['6-200406','16-220515','7-200406','9-200406',"20-220221",'8-200406','002-sa','10-200410']
    const DentEditorAccessPartnerId=['6-200406','7-200406','9-200406','3-190725','17-220221','18-220221','19-220221','amag2022','M-220701']
    let UsCanada_partnerId = ['10-200410','demo-us','21-220515-1',"21-220515","22-220515"]
    const tabViewPath = (client === 'DNS' || client === 'AUS')  && '/TabViewDNS' || client === 'FR' && '/TabViewSwissFrench' || client === 'SWISS' && '/newTabview' || client === 'OTHER' && '/TabView/slovani' || client === 'ROM' && '/TabView/romania' || client === 'CZ' && '/TabViewCZ'
    return (
      <div className="animated fadeIn">
        <Col xs="12" sm="12">
        <Card className="print_button_card mt-2">
            <CardHeader>
              <div className="container-fluid">
                <div className="row align-items-center p-0">
                  <div className="col-lg-4 col-md-4 col-sm-12 col-12 mt-sm-10">
                    <Button className="btn-danger mr-2" onClick={() => this.props.history.goBack()}>{this.lang("Back")}</Button>
                    <small>{client === "SWISS" || client === "POLAND" ?<span>{this.lang("DashboardVIN")} : </span> : 
                      <span>{this.lang("VIN Number")} : </span> } {localStorage.getItem("selectedFile")}</small>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-12 col-12 mt-sm-10 p-0 text-center">
                  {/* {((DentEditorAccessPartnerId.includes(partnerId)) || ['DNS'].includes(client) || UsCanada_partnerId.includes(partnerId)) && */}
                    <Button className="btn-danger" disabled={data && data.Authorized == true} onClick={() => this.props.history.push(`/dentEditor/${partName}`,{imageUrl : this.state.data64Url, url: this.props.url,data64ImgError : this.state.data64ImgError})}>{this.lang("Detailed View")}</Button>
                  {/* } */}
                  </div>
                  {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12 mt-sm-10">
                    <div className="pull-right">
                    <small className="rightLbl">
                    <span>{this.lang("Order No")} :</span> {orderNumber}
                    </small>
                  <Link className="glass" to="/vehicleDentInfo">
                    <button
                      style={{ marginRight: 10 }}
                      className="btn btn-danger btn-sm"
                    >
                      {"<<"} <i className="fa fa-dot-circle-o"></i>
                    </button>
                    </Link>
                        <Link className="glass" to={tabViewPath}>
                      <button className="btn btn-danger btn-sm">
                        <i className="fa fa-dot-circle-o"></i> {">>"}
                      </button>
                    </Link>
                    </div>
                  </div> */}
                </div>
              </div>
            </CardHeader>
          </Card>
          <Card className="m-0">
          {/* <CardHeader>
                <div className="container-fluid p-0">
                  <div className="row p-0">
                  <div className="col-lg-4 col-md-6 col-sm-12 text-left">
                    <Button className="btn-danger mr-2" onClick={() => this.props.history.goBack()}>{this.lang("Back")}</Button>
                    
                    <small> VIN Number : {localStorage.getItem("selectedFile")}</small>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12 text-center">
                  {DentEditorAccessPartnerId.includes(partnerId) &&
                    <Button className="btn-danger" onClick={() => this.props.history.push(`/dentEditor/${partName}`,{imageUrl : this.state.data64Url, url: this.props.url,data64ImgError : this.state.data64ImgError})}>{this.lang("Detailed View")}</Button>
                  }
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12 text-right">
                  <small className="rightLbl">
                      Order No : {orderNumber}
                    </small>
                  <Link className="glass" to="/vehicleDentInfo">
                <button
                  style={{ marginRight: 10 }}
                  className="btn btn-danger btn-sm"
                >
                  {"<<"} <i className="fa fa-dot-circle-o"></i>
                </button>
                </Link>
                    <Link className="glass" to={tabViewPath}>
                  <button className="btn btn-danger btn-sm">
                    <i className="fa fa-dot-circle-o"></i> {">>"}
                  </button>
                </Link>
              
                  </div>
                  </div>
                </div>
            </CardHeader> */}
            { 
            // this.state.softwareType === 'CarSoft' ?
            //   this.state.loader ? <RequestLoader size="60px" style={{ marginLeft: "24px" }} /> 
            //   :
            //   <>
            //     <div className="row">
            //       <div className={this.state.softwareType === 'CarSoft' ? "col-12 col-lg-8 col-md-12 col-sm-12" : "col-12 col-sm-8"}>
            //         <div className="card m-0">
            //           {
            //             (this.state.data64Url) 
            //               ? <ImageEditor prepopulate={true} staticImageUrl={this.state.imageUrl} imageUrl={this.state.data64Url}/> 
            //               : this.state.data64ImgError ? <h4>{this.lang("There was an error loading the image")}</h4> :<RequestLoader size="60px" style={{ marginLeft: "24px" }} /> 
            //           }
            //         </div>
            //       </div>
            //         <div className={this.state.softwareType === 'CarSoft' ? 'col-12 col-lg-4        col-md-12 col-sm-12': ''}>
            //           <div className="row mt-4 p-0">
            //             <div className="col-lg-8 col-sm-6">
            //               <FormGroup>
            //                 <Label>Size Of Damage A *</Label>
            //                 <div className="dropdown mt-1">
            //                   <select
            //                     name="Size_of_damage_A"
            //                     className="form-control p-2"
            //                     onChange={this.handleChange}
            //                     value={Size_of_damage_A}
            //                   >
            //                     {[
            //                       { title: "0 - 3 mm", value: "0 - 3 mm" },
            //                       {
            //                         title: "3 - 15 mm",
            //                         value: "3 - 15 mm",
            //                       },
            //                       {
            //                         title: "15 mm and above",
            //                         value: "15 mm and above",
            //                       },
            //                     ].map((row, ind) => (
            //                       <option key={ind}> {row.title}</option>
            //                     ))}
            //                   </select>
            //                 </div>
            //               </FormGroup>
            //             </div>
            //             <div className="col-lg-4 col-sm-6">
            //               <div className="row align-items-center p-0">
            //                 <div className="col-12 p-0">
            //                   <FormGroup className='m-0'>
            //                     <Label style={{marginLeft:'0.4rem'}}>A</Label>
            //                     <div className="dropdown mt-1">
            //                       <Input
            //                         min={0}
            //                         type="number"
            //                         name="A"
            //                         onChange={this.handleChange}
            //                         className="form-control p-2"
            //                         value={A}
            //                       />
            //                     </div>
            //                   </FormGroup>
            //                 </div>
            //               </div>
            //             </div>
            //             <div className="col-lg-8">
            //               <FormGroup>
            //                 <Label>Size Of Damage B *</Label>
            //                 <div className="dropdown mt-1">
            //                   <select
            //                     name="Size_of_damage_B"
            //                     className="form-control p-2"
            //                     onChange={this.handleChange}
            //                     value={Size_of_damage_B}
            //                   >
            //                     {[
            //                       { title: "0 - 3 mm", value: "0 - 3 mm" },
            //                       {
            //                         title: "3 - 15 mm",
            //                         value: "3 - 15 mm",
            //                       },
            //                       {
            //                         title: "15 mm and above",
            //                         value: "15 mm and above",
            //                       },
            //                     ].map((row, ind) => (
            //                       <option key={ind}> {row.title}</option>
            //                     ))}
            //                   </select>
            //                 </div>
            //               </FormGroup>
            //             </div>
            //             <div className="col-lg-4">
            //               <div className="row align-items-center p-0">
            //                 <div className="col-12 p-0">
            //                   <FormGroup className='m-0'>
            //                     <Label style={{marginLeft:'0.4rem'}}>B</Label>
            //                     <div className="dropdown mt-1">
            //                       <Input 
            //                         min={0}
            //                         type="number"
            //                         name="B"
            //                         onChange={this.handleChange}
            //                         className="form-control p-2"
            //                         value={B}
            //                       />
            //                     </div>
            //                   </FormGroup>
            //                 </div>
            //               </div>
            //             </div>
            //             <div className="col-lg-8">
            //               <FormGroup>
            //                 <Label>Size Of Damage C *</Label>
            //                 <div className="dropdown mt-1">
            //                   <select
            //                     name="Size_of_damage_C"
            //                     className="form-control p-2"
            //                     onChange={this.handleChange}
            //                     value={Size_of_damage_C}
            //                   >
            //                     {[
            //                       { title: "0 - 3 mm", value: "0 - 3 mm" },
            //                       {
            //                         title: "3 - 15 mm",
            //                         value: "3 - 15 mm",
            //                       },
            //                       {
            //                         title: "15 mm and above",
            //                         value: "15 mm and above",
            //                       },
            //                     ].map((row, ind) => (
            //                       <option key={ind}> {row.title}</option>
            //                     ))}
            //                   </select>
            //                 </div>
            //               </FormGroup>
            //             </div>
            //             <div className="col-lg-4">
            //               <div className="row align-items-center p-0">
            //                 <div className="col-12 p-0">
            //                   <FormGroup className='m-0'>
            //                   <Label style={{marginLeft:'0.4rem'}}>C</Label>
            //                     <div className="dropdown mt-1">
            //                       <Input
            //                         min={0}
            //                         type="number"
            //                         name="C"
            //                         onChange={this.handleChange}
            //                         className="form-control p-2"
            //                         value={C}
            //                       />
            //                     </div>
            //                   </FormGroup>
            //                 </div>
            //               </div>
            //             </div>
            //             <div className="col-lg-12 mt-1">
            //               <FormGroup>
            //                 <Label for="exampleText">{this.lang("Comment")}</Label>
            //                 <Input
            //                   type="textarea"
            //                   name="prepopulateComment"
            //                   className="mt-1"
            //                   onChange={this.handleChange}
            //                   value={prepopulateComment}
            //                 />
            //               </FormGroup>
            //             </div>
            //           </div>
            //           <div className="row justify-content-center ml-2 mr-2">
            //             <div
            //               style={{
            //                 display: "flex",
            //                 flexDirection: "row",
            //                 justifyContent: "center",
            //               }}
            //             >
            //               {this.state.toggle_update_btn_loader && (
            //                 <RequestLoader size="32px" style={{ marginRight: "24px" }} />
            //               )}
            //               <Button onClick={this.updatePartDetail}>{this.lang("Update")}</Button>
            //             </div>
            //           </div>
            //       </div>
            //     </div>
            //     {/* <div className="row">
            //       <div className="col-12 col-sm-4">
            //           <div className="card">
            //             <div className="card-header">Dent Positions</div>
            //             <CarDentPositionTable part={dentPositionPartName} />
            //           </div>
            //         </div>
            //     </div>
            //     */}
            //   </>
            //   : 
              this.state.loader ? <RequestLoader size="60px" style={{ marginLeft: "24px" }} /> :
              <div className="row">
                <div className="col-12 col-sm-8">
                  <div className="card m-0">
                    <div className="card-header p-2">
                      {this.lang("Report Image")}
                    </div>
                    {/* {alert(dentInfo && dentInfo.scanresult.length )} */}
                    {
                      this.state.isImgExist ? 
                        <img
                        // src={
                        //   configuration.reportImage +
                        //   partnerId +
                        //   "/" +
                        //   vin + "/" +
                        //   img +
                        //   ".jpg"
                        // }
                        src={data64Url}
                        alt={dentPositionPartName}
                        onError={(img_comp) =>{ 
                          this.setState({
                            isImgExist: false,
                          })
                        }}
                        className="img-fluid"
                       /> :
                       <div className="card-header p-2">
                          {this.lang("Image not found!")}
                       </div>
                    }
                    
                  </div>
                </div>
                <div className="col-12 col-sm-4">
                  <div className="card">
                    <div className="card-header">{this.lang("Dent Positions")}</div>
                    <CarDentPositionTable part={dentPositionPartName} />
                        {/* <div className="table-responsive">
                            <table className="table table-striped">
                              <thead>
                                <tr>
                                  <th>Sn</th>
                                  <th>X</th>
                                  <th>Y</th>
                                  <th>Size</th>
                              
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.partDetails.map((row) => {
                                  return (
                                    <tr>
                                      <td>{row[0] && parseInt(row[0]) + 1}</td>
                                      <td>{row[1]}</td>
                                      <td>{row[2]}</td>
                                      <td>{row[3]}</td>
                                    
                                    </tr>
                                  );
                                })}
                              
                              </tbody>
                            </table>
                          </div> */}
                  </div>
                </div>
              </div>

            }
            {/* <div className="card-footer">
              <Link className="glass" to="/TabView">
                <button className="btn btn-danger btn-sm pull-right">
                  <i className="fa fa-dot-circle-o"></i> {">>"}
                </button>
              </Link>

              <Link className="glass" to="/vehicleDentInfo">
                <button
                  style={{ marginRight: 10 }}
                  className="btn btn-danger btn-sm pull-right"
                >
                  {"<<"} <i className="fa fa-dot-circle-o"></i>
                </button>
              </Link>
            </div> */}
          </Card>
        </Col>
      </div>
    );
  }
}

const mapStateToProps = (props) => {
  return {
    url: props.staticUrl,
  };
};
//export default Colors;
export default connect(mapStateToProps)(PartDetails);
